import AboutModal from './AboutModal';
import AboutModalVersions from './AboutModalVersions';
import AboutModalVersionItem from './AboutModalVersionItem';

AboutModal.Versions = AboutModalVersions;
AboutModal.VersionItem = AboutModalVersionItem;

export { AboutModal, AboutModalVersions, AboutModalVersionItem };


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/AboutModal/index.js
// module id = 611
// module chunks = 0